module.exports = __webpack_public_path__ + "media/images/lb/199-e1d2093ee14a0f1e815c0ad896212079.svg";